import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
import HazyImageHolder from './hazy-image-holder';
import quoteImage from '../assets/alexander-krivitskiy-8gGUMSQQz0E-unsplash@2x.png';
import quoteSignature from '../assets/Billy Baldwin@2x.png';

class QuoteBlock extends Component {
  render() {
    return (
      <Row className="le-quote-block">
        <Col>
          <HazyImageHolder imgSrc={quoteImage} variant="round"/>
          <h5>Be faithful to your own taste, because nothing you really like is ever out of style.</h5>
          <img src={quoteSignature} alt="quote-signature" className="le-quote-signature"/>
        </Col>
      </Row>
    );
  }
}

export default QuoteBlock;